/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PageContent
 */
export interface PageContent {
    /**
     * 
     * @type {string}
     * @memberof PageContent
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PageContent
     */
    path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PageContent
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PageContent
     */
    pageCopy?: string | null;
}

/**
 * Check if a given object implements the PageContent interface.
 */
export function instanceOfPageContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PageContentFromJSON(json: any): PageContent {
    return PageContentFromJSONTyped(json, false);
}

export function PageContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'pageCopy': !exists(json, 'pageCopy') ? undefined : json['pageCopy'],
    };
}

export function PageContentToJSON(value?: PageContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'path': value.path,
        'title': value.title,
        'pageCopy': value.pageCopy,
    };
}

